import { FC, useState } from 'react';
import { Tabs } from 'shared/ui';
import { GeneralSettings } from './GeneralSettings';
import { InterfaceSettings } from './InterfaceSettings';
import { PrivacySettings } from './PrivacySettings';
import { Integrate } from './Integrate';
import { FormikProps } from 'formik';
import { ITavusPersona, ITavusPersonaFormik } from 'entities/tavus/persona';

const tabs = ['Personalized', 'General', 'Privacy', 'Integrate'];

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
  persona: ITavusPersona;
}
export const Settings: FC<IProps> = ({ formik, persona }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const renderTab = () => {
    switch (activeTab) {
      case 'Personalized':
        return <InterfaceSettings formik={formik} />;
      case 'General':
        return <GeneralSettings formik={formik} />;
      case 'Privacy':
        return <PrivacySettings formik={formik} />;
      case 'Integrate':
        return <Integrate persona={persona} formik={formik} />;
    }
  };

  return (
    <div className="ag-flex ag-flex-col ag-h-full">
      <Tabs
        className="ag-overflow-y-hidden"
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <div className="ag-pt-8 ag-space-y-6 ag-max-h-[calc(100%-80px)] lg:ag-max-h-[90vh] ag-overflow-auto ag-scrollbar-none">
        {renderTab()}
      </div>
    </div>
  );
};
